import React, { useEffect, useState } from "react";
import countries from "../utils/countries";
import { MdArrowRight } from "react-icons/md";
import MyModal from "./MyModal";
const SelectField2 = ({ name, label, placeholder, defaultValue, items, onChange, error }) => {
  const [filteredItems, setFilteredItems] = useState(items);
  const [showModal, setShowModal] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const onSearch = (e) => {
    setSearchVal(e.target.val);
  };

  const toggleModalVisibility = () => setShowModal(!showModal);
  const selectedItem = items.find((item) => item.value === defaultValue);
  const getFilteredItems = () => (searchVal === "" ? [...filteredItems] : filteredItems.filter((item) => item.label.includes(searchVal)));

  return (
    <div className="d-flex flex-column gap-2 mb-2">
      <span className="text-black fs-normal">{label}</span>
      <div className="border-0 bg-grey2 py-2 px-3 rounded text-black">
        <button className="d-flex justify-content-between align-items-center bg-transparent w-100" type="button" onClick={toggleModalVisibility}>
          {defaultValue ? <strong className="text-black fs-md">{selectedItem.label}</strong> : <strong className="text-grey2 fs-md fw-regular">{placeholder}</strong>}
          <MdArrowRight color="#000" />
        </button>
      </div>
      <span className="text-danger fs-sm">{error || ""}</span>
      <MyModal isOpen={showModal} onClose={toggleModalVisibility} className={"h-75 overflow-scroll"} modalTitle={label}>
        <input type="text" placeholder="Search" className="border-0 px-2 py-2 bg-grey2 text-black  fs-normal w-100 my-2 rounded" value={searchVal} onChange={onSearch} />
        {getFilteredItems().map((item, i) => (
          <button
            key={i}
            onClick={() => {
              setSearchVal("");
              onChange(item.value);
              toggleModalVisibility();
            }}
            className="bg-transparent w-100 text-start py-2 fs-md text-black fw-medium"
          >
            {item.label}
          </button>
        ))}
      </MyModal>
    </div>
  );
};

export default SelectField2;
